import Vue from 'vue';
import { Component, Inject, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const project = namespace('project');

@Component
export default class AddTaskCategoryModal extends Vue {
  private taskCategoryInput = '';

  @Prop()
  private disabled: boolean;

  @project.Action('addCategory')
  private addCategory(categoryName: string) {
  }

  private onShow() {
    this.taskCategoryInput = '';
  }
}
